import React, { useEffect, useState } from "react";
import { fetchHtml } from "../../lib/Fetching";

export default function RequestedTesting({ sampleId }) {
  const [html, setHtml] = useState("");

  useEffect(() => {
    fetchHtml("/registration/testings/" + sampleId + "/display", {}).then(html =>
      setHtml(html)
    );
  }, []);

  return <div dangerouslySetInnerHTML={{ __html: html }} />;
}
